import type { SchemaCombobox } from '@/modules/ui/models/schema/schema-combobox.ts';
import type { SchemaInput } from '@/modules/ui/models/schema/schema-input.ts';
import type { SchemaTextarea } from '@/modules/ui/models/schema/schema-textarea.ts';
import type { SchemaTextEditor } from '@/modules/ui/models/schema/schema-text-editor.ts';
import type { SchemaButtonToggle } from '@/modules/ui/models/schema/schema-button-toggle.ts';
import type { SchemaDeadline } from '@/modules/ui/models/schema/schema-deadline.ts';
import type { SchemaMessage } from '@/modules/ui/models/schema/schema-message.ts';
import type { SchemaSearchMultiple } from '@/modules/ui/models/schema/schema-search-multiple.ts';
import type { SchemaPrompt } from '@/modules/ui/models/schema/schema-prompt.ts';
import type { SchemaInputNumber } from '@/modules/ui/models/schema/schema-input-number.ts';
import type { SchemaDate } from '@/modules/ui/models/schema/schema-date.ts';
import type { SchemaTileList } from '@/modules/ui/models/schema/schema-tile-list.ts';
import { SchemaCheckbox } from '@/modules/ui/models/schema/schema-checkbox.ts';
import { SchemaSearch } from '@/modules/ui/models/schema/schema-search.ts';
import { SchemaReadonly } from '@/modules/ui/models/schema/schema-readonly.ts';
import type { SchemaHost } from '@/modules/ui/models/schema/schema-host.ts';
export type { ValidatorFn } from '@/modules/common/models/schema/schema-control.ts';

// Можно прописать generic типы, но для простоты оставлен any
/* eslint-disable @typescript-eslint/no-explicit-any */
export type Schema =
  | SchemaCombobox<any, any>
  | SchemaInput
  | SchemaInputNumber
  | SchemaTextarea
  | SchemaTextEditor
  | SchemaButtonToggle<any>
  | SchemaDeadline
  | SchemaMessage
  | SchemaSearch<any>
  | SchemaSearchMultiple<any>
  | SchemaPrompt<any>
  | SchemaDate
  | SchemaTileList
  | SchemaCheckbox
  | SchemaReadonly
  | SchemaHost;
/* eslint-enable @typescript-eslint/no-explicit-any */

export function createSchema(...args: (Schema | false | '' | 0 | null | undefined)[]) {
  return args.filter(Boolean) as Schema[];
}
